module.exports = __webpack_public_path__ + "media/img/pages/companies/schindler-7c9aff92e9fd238c4b1780f775f1b684.jpg";